import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.037 11.985a3.19 3.19 0 0 1 3.188 3.188 3.19 3.19 0 0 1-3.187 3.188 3.19 3.19 0 0 1-3.187-3.187 3.19 3.19 0 0 1 3.187-3.187zm0 1.5a1.69 1.69 0 0 0-1.687 1.688 1.69 1.69 0 0 0 1.688 1.688 1.69 1.69 0 0 0 1.688-1.687 1.69 1.69 0 0 0-1.687-1.687zm4.163-6c1.301 0 2.55.932 2.55 2.304v9.238c0 2.23-2.055 3.858-4.35 3.858H9.6c-2.295 0-4.35-1.628-4.35-3.858V9.789c0-1.372 1.249-2.304 2.55-2.304zm-8.4 1.5c-.687 0-1.049.46-1.05.804v9.238c0 1.202 1.169 2.358 2.85 2.358h4.8c1.681 0 2.85-1.156 2.85-2.358V9.789c0-.344-.363-.804-1.05-.804z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.677 6.58a.75.75 0 1 1-1.062-1.062z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.615 5.518a3.373 3.373 0 0 1 4.769 0 .751.751 0 1 1-1.061 1.062 1.87 1.87 0 0 0-2.646 0l-.53-.531-.531-.53zM7.95 4.021a5.73 5.73 0 0 1 7.885-.203l.214.203.052.057a.75.75 0 0 1-1.056 1.055l-.057-.051-.157-.15a4.23 4.23 0 0 0-5.82.15.75.75 0 0 1-1.061-1.061"
}));
const ForwardRef = forwardRef(SvgComponent);
export const KeyFobUnlockIcon = ForwardRef;